import React from 'react'

import { SearchRecipeTile } from './SearchRecipeTile'
import type { MenuSearchRecipeProps } from './types'

export const MenuSearchRecipe = ({
  recipe,
  context,
  canAddRecipes,
  reachedLimit,
  isInBasket,
  quantity,
  onAddRecipe,
  onBlockedAddAttempt,
  onRecipeClick,
  onRemoveRecipe,
  renderFlexPortionControl,
}: MenuSearchRecipeProps) => {
  const flexPortionControl = isInBasket ? renderFlexPortionControl?.(recipe, context) : undefined

  return (
    <SearchRecipeTile
      recipe={recipe}
      isInBasket={isInBasket}
      canAddRecipes={canAddRecipes}
      reachedLimit={reachedLimit}
      onClick={() => onRecipeClick(recipe, context)}
      onAddClick={() => onAddRecipe(recipe, context)}
      onRemoveClick={() => onRemoveRecipe(recipe, context)}
      onBlockedAddAttempt={onBlockedAddAttempt}
      flexPortionControl={flexPortionControl}
      quantity={quantity}
    />
  )
}
